import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const volunteerEventSchema = Yup.object().shape({
  name: Yup.string().required(i18n.t('profile.volunteer_form.name_required')),
  thumbnail: Yup.array()
    .of(Yup.string().nullable())
    .min(1, i18n.t('profile.volunteer_form.thumbnail_required'))
    .required(),
  location: Yup.string().required(i18n.t('profile.volunteer_form.location_required')),
  address: Yup.string().required(i18n.t('profile.volunteer_form.address_required')),
  description: Yup.string().required(i18n.t('profile.volunteer_form.description_required')),
  startDate: Yup.string().required(i18n.t('profile.volunteer_form.start_date_required'))
});

// Types
export type VolunteerEventData = Yup.InferType<typeof volunteerEventSchema>;

// Resolvers
export const volunteerEventResolver = yupResolver(volunteerEventSchema);
